import { Dialog, type DialogProps } from 'primereact/dialog';
import BulkAddPeopleForm from '../components/BulkAddPeopleForm';
import SingleAddPeopleForm from '../components/SingleAddPeopleForm';
import { TextHeadlineLarge, TextTitleMedium2 } from '@/components/text/Texts';
import { Column } from '@/components/container/Container';
import { MdClose } from 'react-icons/md';
import { EmployeeDto } from '@/types';

interface Props extends DialogProps { type: 'single' | 'bulk' }

export type CreateEmployeeRequest = {
	// 'ID' on mockups. We can't use Id here to avoid confusion with internal ids.;
} & EmployeeDto;

const AddPeopleScreen = (props: Props) => {
	const { visible, onHide, type } = props;

	const headerTemplate = type === 'single' ? (
		<Column className="gap-2 mb-10">
			<TextHeadlineLarge className="text-neutral17" text="Single Add" />
			<TextTitleMedium2
				className="text-onSurfaceVariant"
				text="Fill out the information below to add your employee"
			/>
		</Column>
	) : (<TextHeadlineLarge className="text-neutral17 mb-5" text="Bulk Add" />);

	return (
		<Dialog
			unstyled
			onHide={onHide}
			visible={visible}
			maskStyle={{ backgroundColor: '#00000047' }}
			closeIcon={(<MdClose size={24} className="text-onSurfaceVariant rounded-full duration-200 hover:bg-gray-200" />)}
			pt={{
				root: { className: 'py-6 px-8 rounded-[28px] w-[1136px] tablet:!w-[calc(100vw-6rem)] tablet:!max-w-[calc(100vw-6rem)] bg-white relative' },
				content: { className: 'p-0' },
				header: { className: 'absolute right-6 top-6' }
			}}
		>
			<>
			{headerTemplate}
			{type === 'single'
				? (<SingleAddPeopleForm handleSelfClose={onHide} />)
				: (<BulkAddPeopleForm handleSelfClose={onHide} />)}
			</>
		</Dialog>
	);
};

export default AddPeopleScreen;
